import {fonts} from '../../../../theme/foundations/fonts'
import {pxToRem} from '../../../../utills/pxToRem'
import size from '../../../../utills/size'

export const brandHeroStyle = {
    '.fullwidthbanner': {
        margin: 0,
        [`@media (min-width: ${size.md})`]: {
            width: '100vw',
            left: 'calc(-50vw + 50%)',
            position: 'relative'
        },
        '.fullwidthbanner__item': {
            position: 'relative',
            marginBottom: pxToRem(27),
            img: {
                width: '100%',
                height: 'auto'
            },
            '.fullwidthbanner__content': {
                width: '100%',
                position: 'relative',
                padding: `0 ${pxToRem(15)}`,
                [`@media (min-width: ${size.md})`]: {
                    margin: `0 ${pxToRem(60)}`,
                    background: 'none',
                    backgroundImage: 'none',
                    alignItems: 'left',
                    height: '100%',
                    marginTop: '0',
                    maxWidth: pxToRem(500),
                    position: 'absolute',
                    top: '0'
                },
                '.fullwidthbanner__title': {
                    marginTop: pxToRem(100),
                    h5: {
                        display: 'none'
                    },
                    h3: {
                        color: 'black',
                        fontSize: pxToRem(33),
                        fontFamily: fonts.primary,
                        fontWeight: '700',
                        letterSpacing: pxToRem(2),
                        lineHeight: 'normal',
                        textAlign: 'left',
                        textTransform: 'uppercase',
                        [`@media (min-width: ${size.md})`]: {
                            fontSize: pxToRem(42),
                            fontWeight: '400',
                            textAlign: 'left'
                        }
                    }
                },
                '.fullwidthbanner__body': {
                    p: {
                        margin: `${pxToRem(25)} 0 ${pxToRem(30)}`,
                        color: 'black',
                        fontFamily: fonts.primary,
                        fontWeight: '500',
                        fontSize: pxToRem(16),
                        letterSpacing: pxToRem(1),
                        lineHeight: pxToRem(27),
                        textAlign: 'left',
                        [`@media (min-width: ${size.md})`]: {
                            fontSize: pxToRem(18)
                        }
                    }
                },
                '.fullwidthbanner__button': {
                    paddingBottom: pxToRem(40),
                    a: {
                        backgroundColor: 'cav_brown',
                        color: 'white',
                        fontFamily: fonts.primary,
                        fontSize: pxToRem(14),
                        fontWeight: '600',
                        letterSpacing: pxToRem(2),
                        lineHeight: pxToRem(18),
                        width: '100%',
                        display: 'block',
                        textAlign: 'center',
                        textTransform: 'uppercase',
                        padding: `${pxToRem(14)} ${pxToRem(12)}`
                    },
                    [`@media (min-width: ${size.md})`]: {
                        maxWidth: pxToRem(260),
                        padding: `${pxToRem(14)} ${pxToRem(12)}`
                    }
                }
            }
        }
    }
}
